module.exports = __webpack_public_path__ + "img/_1.9bba2829.png";